import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { mk_widget } from "widgets-for-react";
import { isLoaded } from "../../../Shared/api/apiTypes";
import { hasValues, ready } from "../../../Shared/api/apiUtils";
import { getActivities, getDatesForPeriod } from "../../custom_api/api";
import { emptyOpt, makeOpt } from "../../custom_utils/option";
import { ActivitySummary } from "../components/activity_summary";
import { BlockRenderer } from "../components/block_renderer";
import { contactDetails } from "../components/contact";
import { pushExpand, pushLocationEvent } from "../components/datalayer";
import { Jumbo } from "../components/jumbo";
import { LinkButton } from "../components/library/button";
import { Container } from "../components/library/container";
import { ExpandItem } from "../components/library/expandItem";
import { Link } from "../components/library/link";
import { features } from "../../../Shared/features";
import { OpeningHoursWidget } from "../../../Shared/features/OpeningHours/OpeningHours.widget";
import { combineOpeningHours, fallBackOpeningHour, parseOpeningHours } from "../../../Shared/features/OpeningHours/OpeningHours.state";
import { fetchGooglePlacesOpeningHours } from "../../../Shared/features/OpeningHours/OpeningHours.api";
const locationDetailPageStateZero = {
    activitySummaries: "loading",
    openingTimesOpen: false,
    facilitiesOpen: false,
    parkingOpen: false,
    contactOpen: false,
    googleOpeningHours: "loading"
};
export class LocationDetailPage extends React.Component {
    componentDidMount() {
        const p = this.props;
        const s = this.state;
        const location = p.headerTitle;
        if (isLoaded(p.regions)) {
            const region = p.regions.find((r)=>r.locations.includes(this.props.locationId));
            if (region) {
                pushLocationEvent({
                    location,
                    region: region.name
                });
            } else {
                pushLocationEvent({
                    location
                });
            }
        }
        // Load Google Places opening hours if feature is enabled and we have a Google Places ID
        {
            features().openingHours === 'google' && this.props.googlePlacesId && s.googleOpeningHours == "loading" && fetchGooglePlacesOpeningHours(this.props.googlePlacesId).then((x)=>{
                this.setState((s)=>({
                        ...s,
                        googleOpeningHours: x
                    }));
            });
        }
        if (s.activitySummaries == "loading") {
            getActivities({
                cluster: emptyOpt(),
                edition: emptyOpt(),
                location: makeOpt((q)=>p.locationId ? q.Where((l)=>l.Id.Equals(p.locationId)) : q),
                activity: makeOpt((q)=>q.Where((a)=>a.HideInOverview.Equals(false))),
                region: emptyOpt(),
                event: makeOpt((q)=>q.Where((e)=>{
                        let period = getDatesForPeriod('komend-halfjaar');
                        return e.Date.IsAfter(period.start.toDate()).And(e.Date.IsBefore(period.end.toDate()));
                    }))
            }).then((x)=>{
                this.setState((s, _)=>({
                        ...s,
                        activitySummaries: x
                    }));
            });
        }
        document.title = this.props.pageTitle;
    }
    componentDidUpdate(prevProps, prevState) {
        const prevRegions = prevProps.regions;
        const regions = this.props.regions;
        const location = this.props.headerTitle;
        // If regions fail to load, push location without region and exit
        if (prevRegions != 'error' && regions == 'error') {
            pushLocationEvent({
                location
            });
            return;
        }
        // If regions load, try to find the current and push
        if (prevRegions == 'loading' && isLoaded(regions)) {
            const region = regions.find((r)=>r.locations.includes(this.props.locationId));
            if (region) {
                pushLocationEvent({
                    location,
                    region: region.name
                });
            } else {
                pushLocationEvent({
                    location
                });
            }
        }
    }
    render() {
        const p = this.props;
        const s = this.state;
        let regionQuery = '';
        if (isLoaded(p.regions)) {
            const region = p.regions.find((r)=>r.locations.includes(p.locationId));
            regionQuery = region ? `?waar=${region.slug}` : '';
        }
        const openingHours = parseOpeningHours(s.googleOpeningHours, p.openingHours, p.googlePlacesId);
        const currentOpeningHours = openingHours.filter((item)=>item.day === new Date().getDay());
        return /*#__PURE__*/ _jsxs("div", {
            className: "location-page",
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    kind: "home-location",
                    localizationProps: p.localizationProps,
                    title: p.headerTitle,
                    contents: `${p.description}`,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    size: "small",
                    openingHours: combineOpeningHours(currentOpeningHours) ?? fallBackOpeningHour
                }),
                ready(p.homePageData) && /*#__PURE__*/ _jsx(BlockRenderer, {
                    blocks: p.homePageData.universalBlocks
                }),
                hasValues(s.activitySummaries) && /*#__PURE__*/ _jsx("section", {
                    className: "block block--activity-cluster container--lg align--center",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "block__inner",
                        children: [
                            /*#__PURE__*/ _jsxs("header", {
                                className: "block__header container--m align--center",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "block__title title--l container--xs",
                                        children: "Wat is hier te doen?"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "block__intro container--s",
                                        children: "In deze vestiging wordt van alles georganiseerd. Dit zijn de eerstvolgende activiteiten."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "block__content",
                                children: /*#__PURE__*/ _jsx("ul", {
                                    className: "block__list row teasers",
                                    children: s.activitySummaries.take(6).map((s, i)=>/*#__PURE__*/ _jsx(ActivitySummary, {
                                            headingLevel: "h3",
                                            ...s
                                        }, `activity-summary-${i}`))
                                })
                            }),
                            /*#__PURE__*/ _jsxs("footer", {
                                children: [
                                    /*#__PURE__*/ _jsx(LinkButton, {
                                        className: "button button--primary button--arrow",
                                        handle: p.resetPeriod,
                                        route: `/activiteiten${regionQuery}`,
                                        children: "Bekijk alle activiteiten"
                                    }),
                                    /*#__PURE__*/ _jsx(Link, {
                                        className: "link link--primary link--arrow",
                                        url: "/terugblikken",
                                        children: "Bekijk alle terugblikken"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("section", {
                    className: "block block--expand container--mg align--center",
                    children: /*#__PURE__*/ _jsxs(Container, {
                        children: [
                            /*#__PURE__*/ _jsxs("header", {
                                className: "block__header",
                                children: [
                                    /*#__PURE__*/ _jsx("h2", {
                                        className: "block__title title--l container--xs",
                                        children: "Handige informatie"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "block__intro container--s",
                                        children: "Wil je weten wanneer je terecht kunt? En welke voorzieningen er op deze locatie zijn? Ontdek het hier."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "block__content",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "opening_hours_anchor",
                                        id: "openingstijden"
                                    }),
                                    /*#__PURE__*/ _jsxs("ul", {
                                        className: "block__list expand__list",
                                        children: [
                                            Expand({
                                                key: "openinghours",
                                                title: "Openingstijden",
                                                child: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(OpeningHoursWidget, {
                                                            items: openingHours
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: p.currentContents
                                                            }
                                                        })
                                                    ]
                                                })
                                            }).run((action)=>{
                                                let openNew = action(s.openingTimesOpen);
                                                if (openNew) {
                                                    pushExpand('Openingstijden');
                                                }
                                                this.setState({
                                                    ...s,
                                                    openingTimesOpen: openNew
                                                });
                                            }),
                                            Expand({
                                                key: "facilities",
                                                title: "Voorzieningen",
                                                text: p.aboutContents
                                            }).run((action)=>{
                                                let openNew = action(s.facilitiesOpen);
                                                if (openNew) {
                                                    pushExpand('Voorzieningen');
                                                }
                                                this.setState({
                                                    ...s,
                                                    facilitiesOpen: openNew
                                                });
                                            }),
                                            Expand({
                                                key: "contact",
                                                title: "Contact klantenservice",
                                                child: contactDetails(p.contactCustomerSupport)
                                            }).run((action)=>{
                                                let openNew = action(s.contactOpen);
                                                if (openNew) {
                                                    pushExpand('Contact');
                                                }
                                                this.setState({
                                                    ...s,
                                                    contactOpen: openNew
                                                });
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(BlockRenderer, {
                    blocks: p.blocks
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = locationDetailPageStateZero;
    }
}
function Expand(props) {
    return mk_widget({
        run: ()=>ExpandItem({
                ...props
            })
    });
}
{}